import { ClassNames } from "@emotion/react";
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

import { Background, ContentWrapper, Root } from "./styles";

type BannerProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Content of the Banner in-front of the image.
   */
  children?: ReactNode;
  /**
   * Vertical alignment
   */
  verticalAlignment?: CSSProperties["justifyContent"];
  /**
   * Container for background graphics such as images and video.
   */
  backgroundAssets: ReactNode;
};

export const BannerImageClassName = "BannerImage";

/**
 * A large block-level container with a background image.
 */
export function Banner({
  children,
  className,
  verticalAlignment = "flex-start",
  backgroundAssets,
  ...rest
}: BannerProps): JSX.Element {
  return (
    <ClassNames>
      {({ cx }) => (
        <Root data-testid={Banner.name} className={className} {...rest}>
          <Background className={cx(BannerImageClassName)}>{backgroundAssets}</Background>
          <ContentWrapper verticalAlignment={verticalAlignment}>{children}</ContentWrapper>
        </Root>
      )}
    </ClassNames>
  );
}
